import { InMemoryCache } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';

export const cache: InMemoryCache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        // Filter args are keyArgs: each filter combination keeps its own paginated list,
        // so changing filters swaps the list instead of merging pages across filters.
        allGroupsForLms: relayStylePagination([
          'active',
          'finished',
          'search',
          'courseId',
          'groupIds',
          'lessonDate',
        ]),

        /**
         * The ranked vacancy feed (spec 0035). Not `relayStylePagination`:
         * that helper owns `pageInfo` and drops the fields this connection
         * adds — `totalCount`, `totalCountCapped` and, critically,
         * `relevanceApplied`, which the page reads before it says anything
         * about matching.
         *
         * ⚠️ EVERY filter belongs in `keyArgs`, `sort` included. Miss one and
         * a filtered page-2 gets merged into an unfiltered page-1 — the class
         * of bug this project already hit with keyArgs strings once.
         * `first`/`after` are deliberately absent: they identify a PAGE, not a
         * list, and listing them would give every page its own cache entry and
         * defeat the merge entirely.
         */
        careerVacancyFeed: {
          keyArgs: [
            'directionId',
            'skillIds',
            'cityId',
            'workMode',
            'seniority',
            'employmentType',
            'salaryFrom',
            'freshness',
            'search',
            'savedOnly',
            'sort',
          ],
          merge(existing, incoming, { args }) {
            // No cursor ⇒ this is a fresh first page (a refetch or a filter
            // change), so replace rather than append; otherwise a background
            // `cache-and-network` poll would duplicate the whole list.
            if (!args?.after || !existing) return incoming;
            return {
              ...incoming,
              edges: [...(existing.edges ?? []), ...(incoming.edges ?? [])],
            };
          },
        },
      },
    },
  },
});
